<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        class="elevation-0"
        item-key="eventid"
        :footer-props="footerProps" no-data-text="пусто" no-results-text="ничего не найдено"
        :items-per-page.sync="itemsPerPage"
        dense flat
      >
      <template v-slot:item.iscomplex="{ item }">
        <span v-if="item.iscomplex === true" style="color:#C62828">да</span>
        <span v-else style="color:#42A5F5">нет</span>
      </template>
      <template v-slot:item.saletypeid="{ item }">
        <span v-if="item.saletypeid > 2" style="color:#2E7D32">Бюджет</span>
        <span v-else style="color:#C62828">Платный</span>
      </template>
      <template v-slot:item.rolledback="{ item }">
        <span v-if="item.rolledback" style="color:#C62828">Да</span>
        <span v-else style="color:#2E7D32">Нет</span>
      </template>
      <template v-slot:item.amount="{ item }">
        {{ rubles(item.amount) }} руб.
      </template>
      <template v-slot:item.fee="{ item }">
        {{ rubles(item.fee) }} руб.
      </template>
      <template v-slot:item.cafeid="{ item }">
        {{ item.cafe }}
      </template>
      <template v-slot:item.products="{ item }">
        <v-tooltip left max-width="640">
          <template v-slot:activator="{ on }">
            <v-list-item v-on="on" @click="() => { check=item; dialogCheck=true }" style="min-height: 26px !important">
              <v-list-item-subtitle class="caption pa-0" style="max-width: 60ch !important">
                <span>Товары</span>
              </v-list-item-subtitle>
            </v-list-item>
          </template>
          <span>
            <b>Столовая:</b>
            {{ item.cafe }} <span v-if="item.iscomplex">Комплекс</span><br/><br/>
            <b>Товары:</b><br/>
            <span v-for="p in item.products" :key="p.productid">{{ p.title }} = {{ rubles(p.price) }} руб<br></span>
            <span v-if="item.fee > 0">Комиссия за использование карты = {{ rubles(item.fee) }}</span>
          </span>
        </v-tooltip>
      </template>
      <template v-slot:item.cts="{ item }">
        {{ dateFormat(item.cts) }}
      </template>
      <template v-slot:item.cby="{ item }">
        <div v-if="item.cby" class="person-normal">
          <router-link
          :to="{ name: 'person', params: { personid: item.cby } }"
          style="color: inherit; text-decoration: none"
          >
            <span style="font-size: 14px">
              {{ item.cby }}
            </span>
            <v-icon small>call_made</v-icon>
          </router-link>
        </div>
      </template>
      </v-data-table>
    </v-flex>
    <v-dialog
      v-model="dialogCheck"
      scrollable
      max-width="900px"
      transition="dialog-transition"
      v-if="check"
    >
      <v-card>
        <v-card-title v-if="check" class="title">
          <b>Чек</b>&nbsp; {{check.checkuid}} @&nbsp;<b>{{dateFormat(check.cts)}}</b>
          <v-spacer></v-spacer>
          <v-btn text icon @click="dialogCheck=false"><v-icon>close</v-icon></v-btn>
        <br>
        </v-card-title>
        <v-card-text v-if="check" class="pt-0 px-3">
          <v-container grid-list-xs>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="pl-0">Данные:</v-subheader>
                <span class="fixedcharscaption">Столовая: </span>&nbsp; <b>{{check.cafeid}}</b><br>
                <span class="fixedcharscaption">сумма (+комиссия): </span>&nbsp; <b>{{rubles(check.amount)}} руб</b><br>
                <span class="fixedcharscaption">комиссия: </span>&nbsp; {{rubles(check.fee)}} руб<br>
                <span class="fixedcharscaption">комиссия, ставка: </span>&nbsp; {{check.feerate}} %<br>
                <br>
                <span class="fixedcharscaption">отменено?: </span>&nbsp; {{check.rolledback}} <br>
                <span class="fixedcharscaption">cafeid: </span>&nbsp; {{check.cafeid}} <br>
                <span class="fixedcharscaption">ФИО: </span>&nbsp; {{check.fullname}} <br>
                <span class="fixedcharscaption">комплекс?: </span>&nbsp; {{check.iscomplex}} <br>
                <span class="fixedcharscaption">тип продажи: </span>&nbsp; {{check.saletypeid}} <br>
                <i class="grey--text">(1-карта, 2-касса, 3-сотрудники, >3-бесплатные типы)</i> <br />
                <br>
                <v-subheader class="pl-0">Трансферы:</v-subheader>
                <span class="fixedcharscaption">списание: </span>&nbsp;{{check.tid}}<br />
                <span class="fixedcharscaption">комиссия: </span>&nbsp;{{check.feeid}}<br />
                <span class="fixedcharscaption">отмена: </span>&nbsp; <v-btn v-if="check.rbid !== null" text small class="my-0" color="primary" @click="$emit('search', check.rbid)">{{check.rbid}}</v-btn> <br />
                <span class="fixedcharscaption">отмена, комиссия: </span>&nbsp; <v-btn v-if="check.feerbid !== null" text small class="my-0" color="primary" @click="$emit('search', check.feerbid)">{{check.feerbid}}</v-btn> <br />
              </v-flex>
              <v-flex xs6 style="border-left: 1px solid #ddd" class="pl-5">
                <v-subheader class="pl-0">Продажи товаров: {{ rubles((check.products || []).reduce((r, x) => r + x.price, 0)) }}</v-subheader>
                <span v-for="p in check.products" :key="p.productid"><b>{{rubles(p.price)}} - </b>{{p.title}}<br /></span>
                <span v-if="check.rolledback">ЧЕК ОТМЕНЁН</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogCheck=false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ListChecks',
  props: [ 'checks', 'sort-by', 'search' ],
  data: () => ({
    headers: [
      { text: 'id', value: 'checkid', width: '50' },
      { text: 'Комплекс?', width: '20', value: 'iscomplex', },
      { text: 'Бюджетный?', width: '20', value: 'saletypeid', },
      { text: 'Отменен?', width: '20', value: 'rolledback', },
      { text: 'Стоимость', width: '20', value: 'amount', },
      { text: 'Комиссия', width: '20', value: 'fee', },
      { text: 'Столовая', width: '140', value: 'cafeid', },
      { text: 'Класс', width: '50', value: 'positionname', },
      { text: 'Товары', width: '140', value: 'products', },
      { text: 'Дата создания', width: '140', value: 'cts', },
      { text: 'Продавец', width: '100', value: 'cby', },
    ],
    footerProps: {
      itemsPerPageText: 'показывать записей',
      itemsPerPageOptions: [ 15, 100, { text: 'Все', value: -1 } ]
    },
    itemsPerPage: 15,
    cafes: [],
    items: [],
    dialogCheck: false,
    check: null
  }),
  methods: {
    async fetch () {
      const { cafes } = await this.$store.dispatch('sioRequest', {
        topic: 'fetch-cafes'
      })
      this.cafes = cafes
      this.items = this.checks.map(x => {
        x.cafe = cafes.find(c => c.cafeid === x.cafeid).title
        return x
      })
    },
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    rubles (kops) {
      return (parseFloat(kops) / 100).toFixed(2)
    },
    isBudget (check) {
      return check.saletypeid > 2
    }
  },
  watch: {
    checks (val) {
      if (val) this.fetch()
    }
  },
  mounted () {
    this.fetch()
  }
}
</script>

<style lang="css">
</style>
